import React from 'react';
import { connect } from 'react-redux'
import SeleccionCuentas from './SeleccionCuentas.js';

import {
    getScreenData,
    borrarTarjeta,
    reimprimirTarjeta,
    reimprimirPin,
    modificarSolicitud,
    deleteSolicitudPendiente,
    mostrarAlertaProcesoFinalizado,
    agregarQuitarCuentaVinculo,
    grabarVinculacion,
    cambiarCuentaPrincipal,
    GetVinculosByNroTarjeta,
    mostrarVinculos,
    getHistorialMovimiento,
    crearModificarSolicitudTarjeta,
    getSolicitudesTarjetaByTarjetaId,
    getVinculaciones,
    borrarVinculo,
    mostrarOcultarModalVinculos
} from '../actions/Actions.js';

let _cliente;

const mapStateToProps = (state) => {
    _cliente = state.tarjetas.clienteResultadoBusqueda;

    return {
        plasticos: state.tarjetas,
        data: state.seleccionCuentas,
        cuentas: state.seleccionCuentas.Cuenta,
        isFetching: state.seleccionCuentas.isFetching,
        error: state.seleccionCuentas.error,
        login: state.menuProductos.login
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        getScreenData: (state, currentScope, cuentas, tarjetas, cliente, login) => {
            dispatch(getScreenData(state, currentScope, cuentas, tarjetas, cliente, login));
        },
        borrarTarjeta: (estadoPlastico, tarjetaActual, tipoBorrado, nroCuenta) => {
            dispatch(borrarTarjeta(estadoPlastico, tarjetaActual, tipoBorrado, nroCuenta));
        },
        reimprimirTarjeta: (tarjetaActual, estadoPlastico, nroCuenta) => {
            dispatch(reimprimirTarjeta(tarjetaActual, estadoPlastico, nroCuenta));
        },
        reimprimirPin: (tarjetaActual, estadoPlastico, nroCuenta) => {
            dispatch(reimprimirPin(tarjetaActual, estadoPlastico, nroCuenta));
        },
        modificarSolicitud: (valorModificacion, estadoPlastico, tarjetaActual, nroCuenta) => {
            dispatch(modificarSolicitud(valorModificacion, estadoPlastico, tarjetaActual, nroCuenta));
        },
        deleteSolicitudPendiente: (idSolicitud) => {
            dispatch(deleteSolicitudPendiente(idSolicitud));
        },
        mostrarAlertaProcesoFinalizado: (trueFalse) => {
            dispatch(mostrarAlertaProcesoFinalizado(trueFalse));
        },
        agregarQuitarCuentaVinculo: (cuentaId, seleccionoTodo, agregarQuitarCuentaVinculos) => {
            dispatch(agregarQuitarCuentaVinculo(cuentaId, seleccionoTodo, agregarQuitarCuentaVinculos));
        },
        grabarVinculacion: (cuentasIds, tarjetaId, cuentaPrincipal, estadoPlastico) => {
            dispatch(grabarVinculacion(cuentasIds, tarjetaId, cuentaPrincipal, estadoPlastico));
        },
        cambiarCuentaPrincipal: (cuentaCodigo) => {
            dispatch(cambiarCuentaPrincipal(cuentaCodigo));
        },
        GetVinculosByNroTarjeta: (nroCuenta) => {
            dispatch(GetVinculosByNroTarjeta(nroCuenta));
        },
        mostrarVinculos: () => {
            dispatch(mostrarVinculos());
        },
        getHistorialMovimiento: (nroTarjeta) => {
            dispatch(getHistorialMovimiento(nroTarjeta));
        },
        crearModificarSolicitudTarjeta: (valorModificacion, estadoPlastico, tarjetaActual, nroCuenta) => {
            dispatch(crearModificarSolicitudTarjeta(valorModificacion, estadoPlastico, tarjetaActual, nroCuenta));
        },
        getSolicitudesTarjetaByTarjetaId: (plasticoId) => {
            dispatch(getSolicitudesTarjetaByTarjetaId(plasticoId));
        },
        getVinculaciones: (tarjetaActual, cuentas, tarjetas) => {
            dispatch(getVinculaciones(tarjetaActual, cuentas, tarjetas));
        },
        borrarVinculo: (cuenta) => {
            dispatch(borrarVinculo(cuenta));
        },
        mostrarOcultarModalVinculos: (seMuestra) => {
            dispatch(mostrarOcultarModalVinculos(seMuestra));
        }
    }
}

class SeleccionCuentasContainer extends React.Component {
    componentDidMount() {
        this.props.getScreenData(this.props.routeState, this.props.currentScope, this.props.plasticos.cuentasDelivery, this.props.plasticos.tarjetas, _cliente, this.props.login);
    }

    render() {
        return (
            <SeleccionCuentas
                //Reducers...
                data={this.props.data}
                plasticos={this.props.plasticos}

                cuentas={this.props.plasticos.cuentasDelivery}
                isFetching={this.props.isFetching}
                error={this.props.error}
                saveData={this.props.saveData}
                getExisteSolicitudCuenta={this.props.getExisteSolicitudCuenta}
                clearCuentaActual={this.props.clearCuentaActual}

                borrarTarjeta={this.props.borrarTarjeta}
                reimprimirTarjeta={this.props.reimprimirTarjeta}
                reimprimirPin={this.props.reimprimirPin}
                modificarSolicitud={this.props.modificarSolicitud}
                deleteSolicitudPendiente={this.props.deleteSolicitudPendiente}
                mostrarAlertaProcesoFinalizado={this.props.mostrarAlertaProcesoFinalizado}
                agregarQuitarCuentaVinculo={this.props.agregarQuitarCuentaVinculo}
                grabarVinculacion={this.props.grabarVinculacion}
                cambiarCuentaPrincipal={this.props.cambiarCuentaPrincipal}
                GetVinculosByNroTarjeta={this.props.GetVinculosByNroTarjeta}
                mostrarVinculos={this.props.mostrarVinculos}
                getHistorialMovimiento={this.props.getHistorialMovimiento}
                crearModificarSolicitudTarjeta={this.props.crearModificarSolicitudTarjeta}
                getSolicitudesTarjetaByTarjetaId={this.props.getSolicitudesTarjetaByTarjetaId}
                getVinculaciones={this.props.getVinculaciones}
                borrarVinculo={this.props.borrarVinculo}
                mostrarOcultarModalVinculos={this.props.mostrarOcultarModalVinculos}
                login={this.props.login}

                UserId={this.props.currentScope.UserId}
            />
        );
    }

}

export default connect(mapStateToProps, mapDispatchToProps)(SeleccionCuentasContainer);
